// extracted by mini-css-extract-plugin
export default {"container":"styles_container__70WZE","wrapper":"styles_wrapper__-cc0g","title":"styles_title__LLwrI"};